
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import * as tx from '../../constants/strings';

import LoadingIcon from '../Icons/LoadingIcon';

import './style/_dropdown.scss';

let allActionCreators = Object.assign({});

// Props to be included, all other ignored
const dropdownFilterProps = [
	'id',
	'placeholder', 
	'name',
	'required', 
];

const includes = (obj, includeKeys) =>
	Object.keys(obj).reduce((result, key) => {
		if(includeKeys.includes(key)) {
			result[key] = obj[key];
		}
		return result;
	}, {});

export class SearchableDropdown extends Component {

	constructor(props) {
    super(props);

    this.state = {
    	drawerOpen: false,
    	inputSearchable: '', 
    };
  }

	getRootClass() {
		const propClass = this.props.className ? `${this.props.className}` : '';
		const themeClass = this.props.adminTheme ? 'titanTheme' : '';
		const errorClass = this.props.error ? 'error' : '';

		return `SearchableDropdown ${propClass} ${themeClass} ${errorClass}`;
	}

	handleFocus(evt) {

		if(this.props.onFocus) {
			this.props.onFocus(evt);
		}
	}

	handleBlur(evt) {
		if(this.props.onBlur) {
			this.props.onBlur(evt);
		}
	}

	handleChange(evt) {
		this.setState({ inputSearchable: evt.target.value });
		if(this.props.onChange) {
			this.props.onChange(evt);
		}
	}

	handleSelect(val) {

	}

	render() {
		
		const {t} = this.props;
		const filteredProps = includes(this.props, dropdownFilterProps);
		
		return <div className={this.getRootClass()}>
			<div className={`searchableDropdownLiner`}>
				{this.props.loading ?
					<div className='contentLoading'>
						<div className='loadingLiner'>
							<div className='iconSection'>
								<div className='iconWrapper'>
									<LoadingIcon />
								</div>
							</div>
							<div className='copySection'>
								<div className='copyWrapper'>{t(tx.TX_LOADING)}</div>
							</div>
						</div>
					</div> :
					<div className='contentLoaded'>
						<input 
							{...filteredProps} 
							className={`searchableDropdownInput ${this.props.error ? ' error' : ''}`}
							value={this.state.inputSearchable}
							onFocus={this.handleFocus.bind(this)}
							onBlur={this.handleBlur.bind(this)}
							onChange={this.handleChange.bind(this)} />

						{this.props.options ?
							<div className='optionsWrapper'>
								{this.props.options.map((option, i) => {
									return <div 
													key={i}
													className={'optionWrapper'}
													required={this.props.required ? true : false}
													value={option.value}>
														{this.props.noTranslate ? option.display : t(option.display)}
									</div>
								})}
							</div> :
							null
						}
					</div>
				}
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
  return {

  };
}

export default connect(mapStateToProps, allActionCreators)(withTranslation()(SearchableDropdown));